import React, { useContext } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import classnames from 'classnames';
import { LocaleContext } from 'providers/locale-settings-context';
import CustomDateInput from './CustomDateInput';

export default function CargomaticDatePicker({
  placeholderText,
  selected,
  className,
  onChange,
  onChangeRaw,
  isClearable,
  minDate,
  maxDate,
  disabled,
  dateFormat: dateFormatProp,
}) {
  const localeContext = useContext(LocaleContext);
  const dateFormatContext = localeContext?.localeData?.dateFormat;

  const dateFormat =
    typeof dateFormatProp !== 'undefined' ? dateFormatProp : dateFormatContext;
  function formatDate(selected) {
    if (!selected) {
      return null;
    }
    if (!moment.isMoment(selected)) {
      return moment(selected);
    }
    return selected;
  }
  return (
    (<DatePicker
      isTypeable
      className={classnames(className)}
      placeholderText={placeholderText}
      selected={formatDate(selected)}
      dateFormat={dateFormat}
      onChange={onChange}
      onChangeRaw={onChangeRaw}
      customInput={<CustomDateInput dataTestId="CustomDateInput-d6b3f8e0" />}
      isClearable={isClearable}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
    />)
  );
}
